import { webGetInfo } from '@/api/web'
import { defineStore } from 'pinia'

export type UserDataType = {
  realName: string
  /** 工作城市 */
  workCity: string
  /** 工作行业 */
  workIndustry: string
  /** 入学学院 */
  university: string
  /** 入学年 */
  schoolStartDate: string
}
export const useAppStore = defineStore('app', {
  state: () => ({
    token: window.sessionStorage.getItem('token'),
    userData: {} as UserDataType,
  }),
  getters: {
    realName: (state) => {
      if (state.userData?.realName) {
        return state.userData.realName
      }
      return
    },
    /** 获取当前登录用户的`工作城市` */
    workCity: (state) => {
      if (state.userData?.workCity) {
        return state.userData.workCity
      }
      return
    },
    /** 获取当前登录用户的`工作行业` */
    workIndustry: (state) => {
      if (state.userData?.workIndustry) {
        return state.userData.workIndustry
      }
      return
    },
    /** 获取当前登录用户的`入学学院` */
    university: (state) => {
      if (state.userData?.university) {
        return state.userData.university
      }
      return
    },
    /** 获取当前登录用户的`入学年` */
    schoolStartDate: (state) => {
      if (state.userData?.schoolStartDate) {
        return state.userData.schoolStartDate
      }
      return
    },
  },
  actions: {
    setToken(val: string) {
      this.token = val
      window.sessionStorage.setItem('token', val)
      this.getCurrentInfo()
    },
    getCurrentInfo() {
      if (!this.token) {
        return
      }
      webGetInfo().then((response) => {
        if (response.user) {
          this.userData = response.user
        }
      })
    },
    removeToken() {
      this.token = ''
      window.sessionStorage.removeItem('token')
    },
  },
})
